import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface DialogState {
  dialogIds: string[];
}

const initialState: DialogState = {
  dialogIds: [],
};

export const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    addDialogIdToStack: (state, action: PayloadAction<string>) => {
      state.dialogIds = [...state.dialogIds, action.payload];
    },
    removeDialogIdFromStack: (state, action: PayloadAction<string>) => {
      state.dialogIds = [...state.dialogIds.filter((dId) => dId !== action.payload)];
    },
  },
});

export const { addDialogIdToStack, removeDialogIdFromStack } = dialogSlice.actions;

export const selectActiveDialogId = (state: RootState): string => state.dialog.dialogIds[state.dialog.dialogIds.length - 1];

export default dialogSlice.reducer;
